export default "__VITE_ASSET__CJNC1KQ9__"